import { Observable } from 'rxjs';

import { SettingsModel } from '../models/settings.model';


export abstract class BaseSettingsGetService<T = SettingsModel> {
  public abstract getSettings(...args): Observable<T>;

  public abstract fetchSettings(): Observable<T>;
}
